module.exports = __webpack_public_path__ + "img/iPhone8Plus-2.4ec38366.png";